import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '../services/base-service.service';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class TimezoneService extends BaseService<string, number> {

  constructor(http: HttpClient) {
    super('timezone', http);
  }

  public recuperarTimezones(): Promise<string[]> {
    return firstValueFrom(this.http.get<string[]>(this.path(''), { headers: this.createJsonHttpHeaders() }));
  }

}
